module.exports = __webpack_public_path__ + "static/media/Drake_Well_Museum_Titusville_PA_Faux_painted_rusted_steel_onwooden_box_detail_3_2011.cff09632.webp";